import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {Zaposleni} from 'app/models/lookups/zaposleni';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

import {WorkGroup} from 'app/models/proizvodnja/lookups/WorkGroup';

@Injectable({
  providedIn: 'root' 
})
export class ZaposleniService extends BaseService {
  private listUrl = '/api/zaposleni/list';
  private listViewUrl = '/api/zaposleni/listView';
  private addUrl = '/api/zaposleni/add';
  private deleteUrl = '/api/zaposleni/delete';
  private saveUrl = '/api/zaposleni/save';
   private importZaposleniUrl = '/api/zaposleni/importZaposleni';
  


  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  listZaposleni(qry: Query): Observable<Zaposleni[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Zaposleni[]>(url, AppModulePath.SIFARNICI).pipe(
      map(res => res.map(obj => new Zaposleni(obj))),
      catchError(this.handleError));
  }

  listZaposleniView(): Observable<Zaposleni[]> {
    return this.get<Zaposleni[]>(this.listViewUrl, AppModulePath.SIFARNICI).pipe(
      map(res => res.map(obj => new Zaposleni(obj))),
      catchError(this.handleError));
  }

  save(product: Zaposleni): Observable<Zaposleni> {
    return this.post<Zaposleni>(this.saveUrl, AppModulePath.SIFARNICI, product).pipe(
      map(res => new Zaposleni(res)),
      catchError(this.handleError));
  }

    

  delete(zapId): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + '/' + zapId, AppModulePath.SIFARNICI).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  export(reportName: string, data: any): any {
    console.log(data);
    return this.downloadFile('/api/zaposleni/report/' + reportName, AppModulePath.SIFARNICI, data).pipe(
      map((res) => {
      return new Blob([res], {type: 'application/pdf'});
    }),
    catchError(this.handleError));
  }

  exportZaduzenja(reportName: string, data: any): any {
    console.log(data);
    return this.downloadFile('/api/zaposleni/report/' + reportName, AppModulePath.SIFARNICI, data).pipe(
      map((res) => {
      return new Blob([res], {type: 'application/pdf'});
    }),
    catchError(this.handleError));
  }

   importZaposleni(file: File): Observable<WebMethodResult> {
    const fd: FormData = new FormData();
    fd.append('file', file);
    return this.put<WebMethodResult>(this.importZaposleniUrl, AppModulePath.SIFARNICI, fd).pipe(
      map(res => res),
      catchError(this.handleError));
  }
}
